export interface InputState {
  value: string;
  textWidth: number | null;
}

export enum InputType {
  Text = `text`,
  Password = `password`,
  Number = `number`,
  TextArea = `textarea`,
}

export enum InputSize {
  Small = `small`,
  Medium = `medium`,
  Large = `large`,
}

export enum InputTheme {
  Default = `default`,
  Chrome = `chrome`,
  White = `white`,
}

export enum Necessary {
  Default = ``,
  Optional = `optional`,
  Recommended = `recommended`,
  Required = `required`,
}

export enum ValidationStatus {
  Default = ``,
  Valid = `valid`,
  Invalid = `invalid`,
}

export type InputChangeEvent = CustomEvent<{
  value: string;
}>;

export enum TextAlign {
  Start = `start`,
  Center = `center`,
  End = `end`,
}

export enum AutocompleteType {
  CurrentPassword = `current-password`,
  NewPassword = `new-password`,
  Email = `email`,
  InviteUsersAutocompleteOff = `invite-users-autocomplete-off`,
  Off = `off`,
}
